import React from 'react';
import { SvgIcon } from '@material-ui/core';

export default function DiamIcon() {
  return (
    <SvgIcon viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.6">
        <path
          d="M11 5C9.895 5 9 5.895 9 7V25C9 26.105 9.895 27 11 27H21C22.105 27 23 26.105 23 25V7C23 5.895 22.105 5 21 5H11ZM11 7H21V17H11V7ZM13 9V11H19V9H13ZM13 13V15H19V13H13ZM11 19H21V25H11V19ZM16 20.5C15.172 20.5 14.5 21.172 14.5 22C14.5 22.828 15.172 23.5 16 23.5C16.828 23.5 17.5 22.828 17.5 22C17.5 21.172 16.828 20.5 16 20.5Z"
          fill="white"
        />
      </g>
    </SvgIcon>
  );
}
